export default {
  table: {
    replyType: "回复类型",
    keyword: "关键字",
    content: "回复内容",
    readonly: "是否只读",
    isPrivate: "是否私有回复",
    all: "全部",
    private: "私有",
    public: "公有",
  },
};
